import $ from 'jquery';
import { Collapse } from 'bootstrap/dist/js/bootstrap.esm.js';
import { InfiniteLoop } from './HeaderInfiniteLoop.mjs';
import { deviceIsMinLg } from '../../abstracts/media-queries.mjs';
import { debounce, debounce_leading } from '../../abstracts/debounce.mjs';
import { setGoogleTranslateUrl } from '../../abstracts/google-translate.mjs';
import { SearchInput } from '../SearchInput.mjs';

const SEARCH_INDEX = 0;
const FLYOUTS_INDEX = 1;
const NAVBAR_INDEX = 2;

class Header {
    constructor($headerEl) {
        this.$headerEl = $headerEl;
        this.currentHeight = $headerEl.height();
        this.SearchInstance = null;
        this.isShrunkenHeader = false;
        this.isMobileHeader = false;
        this.isActiveBackdrop = false;
        /*
         * this.collapseInstances => [0] = SEARCH_INDEX & [1] = FLYOUTS_INDEX & [2] = NAVBAR_INDEX
        */
        this.collapseInstances = [undefined, undefined, undefined];
        if (this.$headerEl && this.$headerEl.length) {
            this.init();
        }
    }

    init() {
        this.initHeaderShrinking();
        this.initSkipNavigation();
        this.initCollapseInstances();
        this.initFlyoutMenu();
        this.initCheckMobileHeader();
        this.initMobileMenu();
        this.initHeaderSearch();
        this.initGoogleTranslateLink();
    }

    initHeaderShrinking() {
        this.handleHeaderShrinking();
        $(window).on('scroll', debounce(() => {
            this.handleHeaderShrinking();
        }, 10));
    }

    initSkipNavigation() {
        const $skipWrapper = this.$headerEl.find('.js-skip-navigation');

        if (!$skipWrapper || $skipWrapper.length < 1) {
            return;
        }

        $('a', $skipWrapper).on('focusin', () => {
            $skipWrapper.addClass('is-focus');
        });

        $('a', $skipWrapper).on('focusout', () => {
            setTimeout(function () {
                $skipWrapper.removeClass('is-focus');
            }, 250);
        });
    }

    initCollapseInstances() {
        const collapseButtons = new Array(3);
        const collapseIds = new Array(3);
        const isNotUndefined = (element) => element !== undefined;

        /*
         * collapseButtons => [0] = search & [1] = flyouts & [2] = navbar
        */
        collapseButtons[0] = this.$headerEl.find('.btn__collapse.js-header-search__btn-search[data-bs-target]');
        collapseButtons[1] = this.$headerEl.find('.page-header__main-navigation .nav-level__first > .nav-item > .btn__collapse[data-bs-target]:not(.js-header-search__btn-search)');
        collapseButtons[2] = this.$headerEl.find('.btn__collapse.navbar-toggler[data-bs-target]');

        if (!collapseButtons.some(isNotUndefined)) {
            return;
        }

        $.each(collapseButtons, (outerIndex, buttons) => {
            if (buttons && (buttons.length || buttons instanceof Element )) {
                $(buttons).each((index, button) => {
                    if (button && (button.length || button instanceof Element) && $(button).attr('data-bs-target') !== '') {
                        if (collapseIds[outerIndex] === undefined) {
                            collapseIds[outerIndex] = [$(button).attr('data-bs-target')];
                        } else if (collapseIds[outerIndex].length && !collapseIds[outerIndex].includes($(button).attr('data-bs-target'))) {
                            collapseIds[outerIndex].push($(button).attr('data-bs-target'));
                        }
                    }
                })
            }
        });

        if (!collapseIds.some(isNotUndefined)) {
            return;
        }

        $.each(collapseIds, (outerIndex, ids) => {
            if (ids && ids.length) {
                this.collapseInstances[outerIndex] = new Array(ids.length)
                $.each(ids, (index, id) => {
                    const obj = {
                        id: id,
                        $element: $(id),
                        instance: Collapse.getInstance($(id)[0])
                    }
                    this.collapseInstances[outerIndex][index] = obj;
                })
            }
        });

        this.$headerEl[0].addEventListener('show.bs.collapse', (event) => {
            const targetEl = event.target;
            const targetInstance = Collapse.getInstance(targetEl);

            if (this.collapseInstances.some(isNotUndefined)) {
                $.each(this.collapseInstances, (outerIndex, instances) => {
                    if (instances && instances.length) {
                        $.each(instances, (index, instance) => {
                            if (instance && '$element' in instance && 'instance' in instance) {
                                if (targetEl === instance.$element[0] && targetInstance !== instance.instance) {
                                    this.collapseInstances[outerIndex][index].instance = targetInstance;
                                }
                            }
                        })
                    }
                })
            }
        });

        $(document).on('keyup', (event) => {
            if (event.key === 'Escape') {
                this.handleCollapse('hide-all-mobile');
            }
        })
    }

    initFlyoutMenu() {
        const $firstLevelListItems = this.$headerEl.find('.nav-level__first > .nav-item').filter((index, element) => {
            return $(element).find('> .btn__collapse:not(.js-header-search__btn-search)').length > 0;
        });

        if (!$firstLevelListItems || $firstLevelListItems.length < 1) {
            return;
        }

        this.handleFlyoutMenuMobile();

        $firstLevelListItems.each((index, element) => {
            const $item = $(element)
            const targetId = $item.find('> .btn__collapse[data-bs-target]').attr('data-bs-target');
            const $backBtn = $item.find('.child-nav__back-link');

            if (!$item || $item.length < 1 || !targetId || targetId ==='') {
                return;
            }

            new InfiniteLoop($item, '.nav-link', 'a.nav-link');

            $backBtn.off();
            $backBtn.on('click', debounce_leading((event) => {
                event.stopPropagation();
                this.handleCollapse('hide-all');
                $item.find('button').first().focus();
            }, 150));

            $item.off();
            $item.on({
                mouseenter: () => {
                    if (!this.isMobileHeader) {
                        const tupel = this.hasInstanceEntry(targetId);
                        let mouseenterTimeout = null;

                        if ($item.data('mouseenterTimeout')) {
                            return;
                        }

                        if (tupel && tupel.length === 2 && this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]]) {
                            if (this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]].instance) {
                                mouseenterTimeout = setTimeout(() => {
                                    if ($item.is(':hover')) {
                                        this.handleCollapse('show', tupel);
                                        $firstLevelListItems.each((index, element) => {
                                            $(element).data('mouseenterTimeout', false);
                                            $(element).data('mouseleaveTimeout', false);
                                        });
                                    } else {
                                        $item.data('mouseenterTimeout', false);
                                    }
                                }, 333);
                            } else {
                                mouseenterTimeout = setTimeout(() => {
                                    if ($item.is(':hover')) {
                                        this.handleCollapse('hide-except', tupel);
                                        this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]].instance = new Collapse(this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]].$element[0]);
                                        const $element = this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]].$element;
                                        $element.addClass('collapse-active');
                                        $firstLevelListItems.each((index, element) => {
                                            $(element).data('mouseenterTimeout', false);
                                            $(element).data('mouseleaveTimeout', false);
                                        });
                                    } else {
                                        $item.data('mouseenterTimeout', false);
                                    };
                                }, 333);
                            }
                            $item.find('.tab-guard').last().focus();
                        } else {
                            mouseenterTimeout = setTimeout(() => {
                                if ($item.is(':hover')) {
                                    this.handleCollapse('hide-all');
                                    $firstLevelListItems.each((index, element) => {
                                        $(element).data('mouseenterTimeout', false);
                                        $(element).data('mouseleaveTimeout', false);
                                    });
                                } else {
                                    $item.data('mouseenterTimeout', false);
                                };
                            }, 333);
                        }

                        if (mouseenterTimeout) {
                            $item.data('mouseenterTimeout', mouseenterTimeout);
                        }
                    }
                },
                mouseleave: () => {
                    if (!this.isMobileHeader) {
                        let mouseleaveTimeout = null;

                        if ($item.data('mouseleaveTimeout')) {
                            return;
                        }

                        mouseleaveTimeout = setTimeout(() => {
                            const $hoverItems = $firstLevelListItems.filter((index, element) => $(element).is(':hover'));
                            if (!$hoverItems || $hoverItems.length < 1) {
                                this.handleCollapse('hide-all');
                                $firstLevelListItems.each((index, element) => {
                                    $(element).data('mouseenterTimeout', false);
                                    $(element).data('mouseleaveTimeout', false);
                                });
                            } else {
                                $item.data('mouseleaveTimeout', false);
                            }
                        }, 500);

                        if (mouseleaveTimeout) {
                            $item.data('mouseleaveTimeout', mouseleaveTimeout);
                        }
                    }
                },
                click: debounce_leading((event) => {
                    const tupel = this.hasInstanceEntry(targetId);

                    if (tupel && tupel.length === 2) {
                        this.handleCollapse('hide-except', tupel);
                    } else {
                        this.handleCollapse('hide-all');
                    }
                    $item.find('.nav-level__second').focus();
                }, 150),
                keydown: debounce_leading((event) => {
                    if (event.key === 'Escape') {
                        this.handleCollapse('hide-all');
                        $item.find('button').first().focus();
                    }
                }, 150)
            });
        });

        this.$headerEl.on('header.changeto.mobile header.changeto.desktop', () => {
            this.handleFlyoutMenuMobile();
        })
    }

    initHeaderSearch() {
        const $searchBtn = this.$headerEl.find('.js-header-search__btn-search[data-bs-target]');
        const targetId = $searchBtn && $searchBtn.length ? $searchBtn.attr('data-bs-target') : null;
        const $searchInput = this.$headerEl.find('.input-group.js-search');
        const collapseElementList = [].slice.call(this.$headerEl[0].querySelectorAll('.page-header__search .collapse'));

        if (!$searchBtn || $searchBtn.length < 1 || !targetId || targetId === '' || !collapseElementList || collapseElementList.length < 1 || !$searchInput || $searchInput.length < 1) {
            return;
        }

        const $container = this.$headerEl.find('#header-search');

        this.SearchInstance = new SearchInput($searchInput);

        if ($container.length) {
            new InfiniteLoop($container, '.js-search__reset', 'input');
        }

        if ($searchBtn.length) {
            $searchBtn.on('click', debounce_leading(() => {
                const tupel = this.hasInstanceEntry(targetId);
                if (this.isMobileHeader) {
                    this.handleCollapse('hide-except-mobile', tupel);
                } else {
                    this.handleCollapse('hide-except', tupel);
                }
                $container.find('input').focus();
            }, 150));
            $searchBtn.on('keyup', debounce_leading((event) => {
                const tupel = this.hasInstanceEntry(targetId);
                if (event.key === 'Enter' || event.key === 'Space') {
                    if (this.isMobileHeader) {
                        this.handleCollapse('hide-except-mobile', tupel);
                    } else {
                        this.handleCollapse('hide-except', tupel);
                    }
                    $container.find('input').focus();
                }
            }, 150));
        }

        $(document).on('keyup', (event) => {
            if (event.key === 'Escape') {
                const tupel = this.hasInstanceEntry(targetId);

                if (tupel && tupel.length === 2 && event.target === this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]].$element[0]) {
                    $searchBtn.focus();
                }
            }
        })

        $(document).on('click', '#header-search + .page-header__search-bg', (event) => {
            this.handleCollapse('hide-all');
        })
    }

    initGoogleTranslateLink() {
        const $gTranslateLinks = this.$headerEl.find('.js-gtranslate-link');

        if (!$gTranslateLinks || $gTranslateLinks.length < 1) {
            return;
        }

        $gTranslateLinks.each((index, gTranslateLink) => {
            setGoogleTranslateUrl($(gTranslateLink));
        });
    }

    initCheckMobileHeader() {
        this.handleMobileHeader();
        $(window).on('resize', debounce(() => {
            this.handleMobileHeader();
        }, 150));
    }

    initMobileMenu() {
        const $mobileMenu = this.$headerEl.find('#navigation');
        const $mobileMenu2ndLevelCollapses = $mobileMenu.find('.nav-level__second.collapse');

        if (!$mobileMenu || $mobileMenu.length < 1 || !$mobileMenu.hasClass('collapse')) {
            return;
        }

        if (this.isMobileHeader && this.collapseInstances[NAVBAR_INDEX] && this.collapseInstances[NAVBAR_INDEX][0] && this.collapseInstances[NAVBAR_INDEX][0].$element) {
            const $navEl = this.collapseInstances[NAVBAR_INDEX][0].$element;
            if ($navEl.hasClass('show')) {
                this.handleMobileMenuBackdrop('show');
            }
        }

        const $header = $('.page-header');
        const $headerSiblings = $header.siblings('main,footer,div');

        $mobileMenu[0].addEventListener('show.bs.collapse', (event) => {
            if (event.target === event.currentTarget) {
                this.handleMobileMenuBackdrop('show');
                this.lockFocus($headerSiblings, true);

                const $firstFocusableElement = $mobileMenu.find('button, a').first();
                setTimeout(() => $firstFocusableElement.focus(), 300);
            }
        });

        $mobileMenu[0].addEventListener('hide.bs.collapse', (event) => {
            if (event.target === event.currentTarget) {
                this.handleCollapse('hide-except-mobile', [NAVBAR_INDEX, 0]);
                this.handleMobileMenuBackdrop('hide');
                this.lockFocus($headerSiblings, false);
            }
        });

        const $navFirstLevelItems = $('.nav-level__first > .nav-item > .nav-link, .page-header__service-navigation');

        $mobileMenu2ndLevelCollapses.each((index, collapse) => {
            const $2ndLevelCollapse = $(collapse);

            $2ndLevelCollapse[0].addEventListener('show.bs.collapse', () => {
                setTimeout(() => {
                    this.lockFocus($navFirstLevelItems, true);
                }, 300);
            });
            $2ndLevelCollapse[0].addEventListener('hide.bs.collapse', () => {
                setTimeout(() => {
                    this.lockFocus($navFirstLevelItems, false);
                }, 300);
            });
        })

        this.$headerEl.on('header.changeto.mobile', () => {
            if (this.collapseInstances[NAVBAR_INDEX] && this.collapseInstances[NAVBAR_INDEX][0] && this.collapseInstances[NAVBAR_INDEX][0].$element) {
                const $navEl = this.collapseInstances[NAVBAR_INDEX][0].$element;
                if ($navEl.hasClass('show')) {
                    this.handleMobileMenuBackdrop('show');
                }
            }
        });

        this.$headerEl.on('header.changeto.desktop', () => {
            if (this.isActiveBackdrop) {
                this.handleMobileMenuBackdrop('hide');
            }
        });

        $(document).on('click', '#navigation + .navbar-backdrop', (event) => {
            this.handleCollapse('hide-all-mobile');
        })
    }

    handleFlyoutMenuMobile() {
        if (this.isMobileHeader && this.collapseInstances[FLYOUTS_INDEX]) {
            $.each(this.collapseInstances[FLYOUTS_INDEX], (index, instance) => {
                if (instance.$element.hasClass('collapse') && !instance.$element.hasClass('collapse-horizontal')) {
                    instance.$element.addClass('collapse-horizontal');
                }
            })
        } else if (!this.isMobileHeader && this.collapseInstances[FLYOUTS_INDEX]) {
            $.each(this.collapseInstances[FLYOUTS_INDEX], (index, instance) => {
                if (instance.$element.hasClass('collapse') && instance.$element.hasClass('collapse-horizontal')) {
                    instance.$element.removeClass('collapse-horizontal');
                }
            })
        }
    }

    lockFocus($elements, enable) {
        $elements.attr('aria-hidden', enable ? 'true' : null);
    }

    handleMobileMenuBackdrop(handler = 'hide') {
        const $mobileMenu = this.$headerEl.find('#navigation');

        if (!$mobileMenu || $mobileMenu.length < 1) {
            return;
        }

        const $body = $('body');

        switch (handler) {
            case 'show':
                !$body.hasClass('body-lock') ? $body.addClass('body-lock') : '';
                if ($mobileMenu.next('.navbar-backdrop').length) {
                    $mobileMenu.next('.navbar-backdrop').fadeIn();
                } else {
                    const backdrop = document.createElement('div');
                    $(backdrop).addClass('navbar-backdrop');
                    $(backdrop).css('display', 'none');
                    $mobileMenu.parent().append(backdrop);
                    $mobileMenu.next('.navbar-backdrop').fadeIn();
                }
                this.isActiveBackdrop = true;
                break;
            case 'hide':
                $body.hasClass('body-lock') ? $body.removeClass('body-lock') : '';
                if ($mobileMenu.next('.navbar-backdrop').length) {
                    $mobileMenu.next('.navbar-backdrop').fadeOut();
                }
                this.isActiveBackdrop = false;
                break;
            default:
                break;
        }
    }

    handleHeaderShrinking() {
        const scrollTop = $(window).scrollTop();
        if (scrollTop > 50) {
            this.$headerEl.addClass('shrinked');
            this.isShrunkenHeader = true;
            this.$headerEl.trigger('header.shrinked');
        } else {
            this.$headerEl.removeClass('shrinked');
            this.isShrunkenHeader = false;
            this.$headerEl.trigger('header.unshrinked');
        }
    }

    handleCollapse(handler, tupel = null) {
        const isNotUndefined = (element) => element !== undefined;
        if (handler) {
            switch (handler) {
                case 'hide-all':
                    if (this.collapseInstances && this.collapseInstances.some(isNotUndefined)) {
                        $.each(this.collapseInstances, (outerIndex, instances) => {
                            if (outerIndex !== 2 && instances && instances.some(isNotUndefined)) {
                                $.each(instances, (index, instance) => {
                                    if (instance.instance) {
                                        const $element = instance.$element;
                                        $element.removeClass('collapse-active');
                                        instance.instance.hide();
                                    }
                                })
                            }
                        })
                    }
                    break;
                case 'hide-all-mobile':
                    if (this.collapseInstances && this.collapseInstances.some(isNotUndefined)) {
                        $.each(this.collapseInstances, (outerIndex, instances) => {
                            if ((this.isMobileHeader || outerIndex !== NAVBAR_INDEX) && instances && instances.some(isNotUndefined)) {
                                $.each(instances, (index, instance) => {
                                    if (instance.instance) {
                                        const $element = instance.$element;
                                        $element.removeClass('collapse-active');
                                        instance.instance.hide();
                                    }
                                })
                            }
                        })
                    }
                    break;
                case 'hide-except':
                    if (tupel && tupel.length === 2) {
                        if (this.collapseInstances && this.collapseInstances.some(isNotUndefined)) {
                            $.each(this.collapseInstances, (outerIndex, instances) => {
                                if (outerIndex !== NAVBAR_INDEX && instances && instances.some(isNotUndefined)) {
                                    $.each(instances, (index, instance) => {
                                        if (instance.instance && (outerIndex !== tupel[0] || (outerIndex === tupel[0] && index !== tupel[1]))) {
                                            const $element = instance.$element;
                                            $element.removeClass('collapse-active');
                                            instance.instance.hide();
                                        }
                                    })
                                }
                            })
                        }
                    }
                    break;
                case 'hide-except-mobile':
                    if (tupel && tupel.length === 2) {
                        if (this.collapseInstances && this.collapseInstances.some(isNotUndefined)) {
                            $.each(this.collapseInstances, (outerIndex, instances) => {
                                if ((this.isMobileHeader || outerIndex !== NAVBAR_INDEX) && instances && instances.some(isNotUndefined)) {
                                    $.each(instances, (index, instance) => {
                                        if (instance.instance && (outerIndex !== tupel[0] || (outerIndex === tupel[0] && index !== tupel[1]))) {
                                            const $element = instance.$element;
                                            $element.removeClass('collapse-active');
                                            instance.instance.hide();
                                        }
                                    })
                                }
                            })
                        }
                    }
                    break;
                case 'show':
                    if (tupel && tupel.length === 2) {
                        if (this.collapseInstances && this.collapseInstances.some(isNotUndefined)) {
                            $.each(this.collapseInstances, (outerIndex, instances) => {
                                if (outerIndex !== 2 && instances && instances.some(isNotUndefined)) {
                                    $.each(instances, (index, instance) => {
                                        if (instance.instance && (outerIndex !== tupel[0] || (outerIndex === tupel[0] && index !== tupel[1]))) {
                                            const $element = instance.$element;
                                            $element.removeClass('collapse-active');
                                            instance.instance.hide();
                                        } else if (instance.instance && outerIndex === tupel[0] && index === tupel[1]) {
                                            const $element = instance.$element;
                                            $element.addClass('collapse-active');
                                            instance.instance.show();
                                        }
                                    })
                                }
                            })
                        }
                    }
                    break;
                default:
                    this.handleCollapse('hide-all')
                    break;
            }
        }
    }

    handleMobileHeader() {
        if (this.isMobile && !this.isMobileHeader) {
            this.isMobileHeader = true;
            this.$headerEl.trigger('header.changeto.mobile');
        } else if (!this.isMobile && this.isMobileHeader) {
            this.isMobileHeader = false;
            this.$headerEl.trigger('header.changeto.desktop');
        }
    }

    // Not used atm
    showError(error = null) {
        switch (error) {
            case 'no-header-el':
                return 'No header element can be found';
            case 'no-first-level-nav-items':
                return 'No first level navigation items can be found';
            case 'no-first-level-nav-items':
                return 'No skip navigation element can be found'
            default:
                return 'An error occured';
        }
    }

    hasInstanceEntry(targetId) {
        const isNotUndefined = (element) => element !== undefined;
        let parentIndex = null;
        let elementIndex = null;
        let found = false;
        let result = null;

        if (targetId && this.collapseInstances.some(isNotUndefined)) {
            $.each(this.collapseInstances, (outerIndex, instances) => {
                if (!found && instances.some(isNotUndefined)) {
                    $.each(instances, (index, instance) => {
                        if (!found && instance && instance.id === targetId) {
                            found = true;
                            result = [outerIndex, index];
                        }
                    })
                }
            })
            return result;
        }
    }

    hasInstance(targetId) {
        const isNotUndefined = (element) => element !== undefined;
        let parentIndex = null;
        let elementIndex = null;

        if (targetId && this.collapseInstances.some(isNotUndefined)) {
            const tupel = this.hasInstanceEntry(targetId);

            if (tupel && tupel.length === 2) {
                return this.collapseInstances[tupel[SEARCH_INDEX]][tupel[1]].instance;
            }
        }
    }

    get isMobile() {
        if (deviceIsMinLg.matches) {
            return false;
        } else {
            return true;
        }
    }
}

init100vhVar();
initHeader();

function initHeader() {
    const $elements = $('.page-header');

    if ($elements.length < 1) {
        return;
    }

    // only handle the first header and hide all sub-
    // sequent implementations - if there are any 😜
    $elements.filter((index, element) => {
        return index !== 0;
    }).addClass('d-none');

    new Header($elements.eq(0));
}

/**
 * Workaround till dhv unit has a broader supported
 * @see https://stackoverflow.com/a/58886798/10706764
 */
function init100vhVar() {
    // If less than most tablets, set CSS var to window height.
    let value = '100vh';

    setVar();
    $(window).on('resize', debounce(setVar, 150));

    function setVar() {
        if (window.innerWidth) {
            value = `${window.innerHeight}px`;
        }

        document.documentElement.style.setProperty('--real100vh', value);
    }
}
